import { CreateLegalClientHeadParams } from 'api/types/params';
import { isFinanceProject, isGlobalProject } from 'config';
import {
  parseTaxResidencyParam,
  parsePepConnectionParam,
  parseCitizenshipsParam,
  parseAddressWithFilesParam,
} from 'modules/client/common/helpers';
import { parseHeadPositionParam } from 'modules/client/common/helpers/parseParams/parseHeadPositionParam';

import { LegalClientHeadFormType } from '../../forms/legalClientHeadForm';

export const getLegalClientHeadSubmitData = (
  legalClientId: string,
  versionNumber: number,
  values: LegalClientHeadFormType
): CreateLegalClientHeadParams => {
  const addressParam = parseAddressWithFilesParam(values);
  const isGlobal = isGlobalProject();
  const isFinance = isFinanceProject();

  return {
    versionNumber,
    email: values.personalData?.email!,
    legalClientId,
    reason: values.reasonChange.reason,
    firstName: values.personalData!.firstName!,
    lastName: values.personalData!.lastName!,
    middleName: values.personalData!.middleName ?? null,
    dateOfBirth: values.personalData!.dateOfBirth!,
    citizenships: parseCitizenshipsParam(values),

    registrationAddress: isFinance
      ? addressParam.registrationAddress
      : undefined,
    residentialAddress: addressParam.residentialAddress,
    placeOfBirth: isGlobal ? addressParam.placeOfBirth : undefined,

    taxResidences: parseTaxResidencyParam(values),

    pepConnection: values.pepConnection.relation?.value!,
    connectedPepInfo: isFinance ? parsePepConnectionParam(values) : undefined,

    position: parseHeadPositionParam(values),
  };
};
